// Used for GQL. NOT the same as listOfUSAStates.
export const US_STATE = {
  // US States
  AL: "AL",
  AK: "AK",
  AZ: "AZ",
  AR: "AR",
  CA: "CA",
  CO: "CO",
  CT: "CT",
  DE: "DE",
  FL: "FL",
  GA: "GA",
  HI: "HI",
  ID: "ID",
  IL: "IL",
  IN: "IN",
  IA: "IA",
  KS: "KS",
  KY: "KY",
  LA: "LA",
  ME: "ME",
  MD: "MD",
  MA: "MA",
  MI: "MI",
  MN: "MN",
  MS: "MS",
  MO: "MO",
  MT: "MT",
  NE: "NE",
  NV: "NV",
  NH: "NH",
  NJ: "NJ",
  NM: "NM",
  NY: "NY",
  NC: "NC",
  ND: "ND",
  OH: "OH",
  OK: "OK",
  OR: "OR",
  PA: "PA",
  RI: "RI",
  SC: "SC",
  SD: "SD",
  TN: "TN",
  TX: "TX",
  UT: "UT",
  VT: "VT",
  VA: "VA",
  WA: "WA",
  WV: "WV",
  WI: "WI",
  WY: "WY",

  // US Territories and Federal District
  AS: "AS", // American Samoa
  DC: "DC", // District of Columbia
  GU: "GU", // Guam
  MP: "MP", // Northern Mariana Islands
  PR: "PR", // Puerto Rico
  VI: "VI", // Virgin Islands

  // Freely Associated States
  FM: "FM", // Federated States of Micronesia
  MH: "MH", // Marshall Islands
  PW: "PW", // Palau
} as const;
export type USState = keyof typeof US_STATE;
export type StatesWithoutTerritories = Exclude<
  USState,
  "AS" | "GU" | "MP" | "FM" | "MH" | "PW" | "PR" | "VI"
>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isUsState = (state: any): state is keyof typeof US_STATE =>
  Object.values(US_STATE).includes(state);
